import { Component, Input } from '@angular/core'
import { MatCard } from '@angular/material/card'
import { NgStyle } from '@angular/common'

@Component({
	selector: 'card-component',
	templateUrl: './Card.Component.html',
	styleUrls: ['./Card.Component.css'],
	imports: [MatCard, NgStyle],
})
export class CardComponent {
	@Input() public styles: { [key: string]: string | number }
}
